import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-general-4',
  templateUrl: './4.component.html',
})
export class VbGeneral4Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
